import * as mutations from "./mutation-types";
import api from "@/api";

export const getCustomer = async ({ commit }, id = null) => {
  if (!id) {
    let res = await api.customer.me();
    commit(mutations.SET_CURRENT_CUSTOMER, {
      ...res.data,
      friendListId: res.data.friendList ? res.data.friendList.code : null,
      invitedFriendListId: res.data.invitedFriendList
        ? res.data.invitedFriendList.code
        : null,
    });
    commit(mutations.ADD_CUSTOMER, res.data);

    return res;
  }

  let res = await api.customer.get(id);
  commit(mutations.ADD_CUSTOMER, res.data);

  return res;
};

export const getCustomers = async ({ commit }) => {
  let res = await api.customer.all();
  commit(mutations.SET_CUSTOMERS, res.data["hydra:member"]);

  return res;
};

export const resetCustomer = async ({ commit }) => {
  commit(mutations.RESET_CURRENT_CUSTOMER);
};

export const getCustomerLevels = async ({ state, commit }) => {
  let res = await api.customer.levels(state.current);
  commit(mutations.SET_CUSTOMER_LEVELS, res.data["hydra:member"]);

  return res;
};

export const setCustomer = async ({ commit }, customer) => {
  commit(mutations.ADD_CUSTOMER, customer);
};

export const register = (context, data) => {
  return api.customer.register(data);
};

export const updateSettings = async ({ commit }, data) => {
  let res = await api.customer.updateSettings(data);
  commit(mutations.ADD_CUSTOMER, res.data);

  return res;
};

export const updateCustomer = async ({ commit }, data) => {
  if (data.id) {
    const id = data.id;
    delete data.id;
    let res = await api.customer.update(id, data);
    commit(mutations.ADD_CUSTOMER, res.data);
    return;
  }

  let res = await api.customer.updateMe(data);
  commit(mutations.ADD_CUSTOMER, res.data);

  return res;
};

export const confirmCustomer = async ({ commit }, confirmationToken) => {
  await api.customer.confirm(confirmationToken);
  let res = await api.customer.me();
  commit(mutations.ADD_CUSTOMER, res.data);

  return res;
};

export const sendConfirm = async (store = {}, payload) => {
  return await api.customer.sendConfirm(payload);
};

export const completeWalkthroughVideo = async ({
  commit,
  dispatch,
  getters,
}) => {
  commit(mutations.UPDATE_CUSTOMER, {
    firstClubVideoCompleted: true,
    id: getters.customer.id,
  });

  return await dispatch("updateCustomer", { firstClubVideoCompleted: true });
};

export const completeIntroTour = async ({ commit, dispatch, getters }) => {
  commit(mutations.UPDATE_CUSTOMER, {
    firstClubTourCompleted: true,
    id: getters.customer.id,
  });

  return await dispatch("updateCustomer", { firstClubTourCompleted: true });
};
